import styled from 'styled-components';
import { THEME } from '../../../../themes';
import { Body1Font, HeadlineFont } from '../../../../themes/fonts';
import { ASSETS } from '../../../../assets';

export const Section = styled.div`
  width: 100%;

  &:not(:last-child) {
    &:after {
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      background-color: ${THEME.COLORS.CONTENT_PRIMARY};
      opacity: ${THEME.OPACITY.GHOST};
      margin-top: ${THEME.SPACING.XLOOSE};
    }
  }
`;

export const SectionTitle = styled.div`
  ${HeadlineFont};
  text-transform: capitalize;
  color: ${THEME.COLORS.CONTENT_A};

  & > span {
    margin-right: ${THEME.SPACING.TINO};
  }
`;

export const InfoText = styled.div`
  ${Body1Font};
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.MICRO};
  margin-top: ${THEME.SPACING.MICRO};
`;

export const InfoTextIcon = styled(ASSETS.ASTERISK)`
  fill: ${THEME.COLORS.CONTENT_A};
`;

export const SectionBody = styled.div`
  margin-top: ${THEME.SPACING.MEDIUM};
`;
